import {Locale} from '../../../types';

const countriesWithBackupArticle = [
  Locale.fr_FR,
  Locale.it_IT,
  Locale.es_ES,
  Locale.pt_PT,
];

export const getKlarnaPlaceholder = (articleId: number, locale: Locale) => {
  const klarnaLocale = locale.replace('_', '-');

  switch (articleId) {
    case 360016029639:
      return `<klarna-placement data-key="info-page" data-locale="${klarnaLocale}" />`;

    case 5702760305820:
      if (countriesWithBackupArticle.includes(locale)) {
        return `<klarna-placement data-key="info-page" data-locale="${klarnaLocale}" />`;
      }
      return '';
    default:
      return '';
  }
};
